import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import './ListItem.scss';
export const ListItem = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
({ data, color, isActive, isHovered, stripePosition, renderChildren, onPress, onMouseEnter, onMouseLeave, children, testId, }, ref) => {
    const itemRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            itemRef.current && itemRef.current.focus();
        },
    }));
    const handleKeyDown = useCallback((e) => {
        switch (e.keyCode) {
            case 13: // Enter
                onPress?.(e, { data: data });
                break;
        }
    }, [onPress, data]);
    let className = '';
    className += onPress ? ' sg-listItem-clickable' : '';
    className += isActive ? ' sg-listItem-isActive' : '';
    className += isHovered ? ' sg-listItem-isHovered' : '';
    className += stripePosition === 'right' ? ' sg-listItem-right' : '';
    className += stripePosition === 'left' ? ' sg-listItem-left' : '';
    const currentChildren = renderChildren ? renderChildren(data) : children;
    return (_jsx("li", { className: 'sg-listItem' + className, style: { color: color }, tabIndex: onPress ? 0 : undefined, ref: itemRef, onClick: onPress ? (e) => onPress?.(e, { data: data }) : undefined, onKeyDown: onPress ? handleKeyDown : undefined, onMouseEnter: onMouseEnter ? (e) => onMouseEnter?.(e, { data: data }) : undefined, onMouseLeave: onMouseLeave ? (e) => onMouseLeave?.(e, { data: data }) : undefined, "data-test-id": testId, children: _jsx("div", { className: 'sg-listItem--inner', children: currentChildren }) }));
});
//# sourceMappingURL=ListItem.js.map